{
  "list": {
    "title": "العملاء",
    "subtitle": "{{n}} عميلاً",
    "searchLabel": "بحث في العملاء",
    "searchPlaceholder": "الاسم، الجوال، البريد",
    "new": "عميل جديد",
    "caption": "العملاء",
    "empty": {
      "title": "لا يوجد عملاء",
      "noMatches": "لا توجد نتائج مطابقة للبحث.",
      "addFirst": "أضف أول عميل للبدء."
    },
    "columns": {
      "name": "العميل",
      "phone": "الجوال",
      "email": "البريد",
      "bookings": "الحجوزات",
      "lastBooking": "آخر حجز",
      "totalPaid": "مجموع المدفوع"
    }
  },
  "drawer": {
    "email": "البريد",
    "bookings": "الحجوزات",
    "totalPaid": "مجموع المدفوع",
    "linked": "مرتبط",
    "notLinked": "غير مرتبط",
    "edit": "تعديل",
    "bookingsTitle": "الحجوزات",
    "noBookings": "لا توجد حجوزات",
    "newBooking": "حجز جديد لهذا العميل"
  },
  "form": {
    "firstName": "الاسم الأول",
    "lastName": "اسم العائلة",
    "phone": "رقم الجوال",
    "phoneHint": "تصله الفاتورة ورابط الدفع برسالة SMS",
    "existing": "العميل موجود مسبقاً.",
    "viewExisting": "عرض العميل",
    "email": "البريد الإلكتروني (اختياري)",
    "notes": "ملاحظات",
    "saving": "جاري الحفظ…",
    "save": "حفظ العميل",
    "saved": "تم حفظ التعديلات",
    "created": "تم إضافة العميل",
    "saveFailed": "تعذر الحفظ",
    "errors": {
      "firstName": "الاسم الأول مطلوب",
      "lastName": "اسم العائلة مطلوب",
      "phone": "رقم جوال غير صالح (مثال: 5XXXXXXXX)",
      "email": "بريد إلكتروني غير صالح",
      "phoneExists": "يوجد عميل بنفس رقم الجوال"
    },
    "useExisting": "اختيار هذا العميل"
  }
}
